export const APP_VERSION = '0.1.1';
export const BUILD_DATE = '2026-07-23T10:24:56Z';
export const COMMIT_HASH = 'aaf74446';
export const BUILD_DATE_UTC = '2026-07-23T10:24:56Z';
export const BUILD_DATE_IST = '2026-07-23T15:54:56+05:30';
export const ENVIRONMENT = 'stage';
